import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "back",
  "use": "back-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"back\"><path d=\"M958.144 454.08h-681.92l312.96-313.088-78.208-78.208L63.808 509.952 510.976 957.12l78.208-78.208-312.96-313.088H958.08z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol